import toast, { Toaster } from "react-hot-toast";
import { LastActivityObj } from "@/hooks/useIdleApp";
import { useEffect } from "react";
import { LAST_ACTIVITY, LocalStorageService } from "@/utils/local-data";
import { useTranslations } from "next-intl";

export function InactivityWarning() {
  const t = useTranslations("signin");

  useEffect(() => {
    const lastActivity =
      LocalStorageService.getData<LastActivityObj>(LAST_ACTIVITY);

    const itsToday = lastActivity?.date
      ? new Date(lastActivity.date).toDateString() === new Date().toDateString()
      : false;
    if (
      lastActivity?.date &&
      lastActivity?.inactivity &&
      itsToday // Solo mostramos el warning si es de hoy, sino se asume que de un dia para el otro no se guarda la sessión
    ) {
      const activityDate = new Date(lastActivity.date);
      const time = activityDate.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      });
      toast(
        (to) => (
          <div className="flex flex-col text-center">
            {t("inactivity.title", { time })}
            <button
              className="border rounded mt-2 p-2 w-auto"
              onClick={() => {
                LocalStorageService.saveData<LastActivityObj>(LAST_ACTIVITY, {
                  inactivity: false,
                });
                toast.dismiss(to.id);
              }}
            >
              {t("inactivity.button")}
            </button>
          </div>
        ),
        {
          duration: Infinity,
        },
      );
    }
  }, []);

  return <Toaster />;
}
